import React from 'react';
import PropTypes from 'prop-types';
import styles from './Carousel.module.less';

export default function Navigation({ callback, index, active }) {
  return (
    <div
      className={active ? styles.active : ''}
      onClick={() => callback(index)}
    ></div>
  );
}

Navigation.propTypes = {
  active: PropTypes.bool.isRequired,
  callback: PropTypes.func,
  index: PropTypes.number,
};
